import { Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { Metadata } from '../interfaces/metadata';
import * as $ from 'jquery';
declare var window;

@Injectable()
export class MetaDataService {

  constructor(
    private metaService: Meta,
    private titleService: Title
  ) { }

  public setStatusCode(code: string = '200') {
    this.metaService.updateTag({content: code}, 'name="prerender-status-code"');
  }

  public updateMetadata(metadata?: Metadata) {
    let defaultMeta: Metadata;
    let combinedMeta: Metadata;
    defaultMeta = {
      meta_title: 'auburn',
      meta_description: 'Inspired American Cuisine by Chef Eric Bost. ' +
        'Our approach is simple. We have a passion for pure flavor, quality ingredients, ' +
        'and for creating an atmosphere that is layered, approachable, and a haven for people who simply love food.',
      meta_image: `${window.location.origin}/assets/images/share.jpg`,
      meta_keywords: 'auburn, auburn la, eric bost, chef eric bost, american cuisine la',
    };

    // Use default values if none are supplied
    combinedMeta = Object.assign({}, defaultMeta, metadata);
    // Set meta tags / title
    const strippedTitle = $('<textarea/>').html(combinedMeta.meta_title).text();
    const strippedDescription = $('<textarea/>').html(combinedMeta.meta_description).text();

    this.titleService.setTitle(strippedTitle);

    if (combinedMeta.meta_image && combinedMeta.meta_image[0] === '/') {
      // contentful images coming in missing https which messes up FB and Twitter scrappers
      combinedMeta.meta_image = 'https:' + combinedMeta.meta_image;
    }

    this.metaService.updateTag({content: strippedTitle}, 'property="og:title"');
    this.metaService.updateTag({content: strippedDescription}, 'name="description"');
    this.metaService.updateTag({content: strippedDescription}, 'property="og:description"');
    this.metaService.updateTag({content: combinedMeta.meta_keywords}, 'name="keywords"');
    this.metaService.updateTag({content: combinedMeta.meta_image}, 'property="og:image"');
    this.metaService.updateTag({content: window.location.href}, 'property="og:url"');
    this.metaService.updateTag({content: strippedTitle}, 'name="twitter:title"');
    this.metaService.updateTag({content: strippedDescription}, 'name="twitter:description"');

    window.prerenderReady = true;
    this.setStatusCode('200');

    // TODO 404 prerender status?
  }

  setMetaData(content: Metadata) {
    // Clear out metadata just in case
    const _metadata: Metadata = {};

    if (content) {
      if (content.meta_title) {
        _metadata.meta_title = content.meta_title;
      }
      if (content.meta_description) {
        _metadata.meta_description = content.meta_description;
      }
      if (content.meta_keywords) {
        _metadata.meta_keywords = content.meta_keywords;
      }
      if (content.meta_image) {
        _metadata.meta_image = content.meta_image;
      }
    }

    this.updateMetadata(_metadata);
  }
}
